const ROUTES = {
  home: "/",
  reservationList: "/reservation-list",
  scheduleList: "/appointment-list",
  makeAppointmentPage: "/make-appointment/:id",
  reservationDetail: "/reservation-detail/:id",
}

export default ROUTES
